import http, { url } from '../../http'

const API_URL = "report_raei"

class accidentAPI {

  async save(accident) { 
    const response = await http(`${API_URL}/save`, 'POST', accident)
    return response
  }

  async getAllreport(id, fecha) {
    const response = await http(`${API_URL}/${id}` , 'POST', fecha )
   
    return response
  } 
  async getAllGrafica(id, fecha) {
    const response = await http(`${API_URL}/example/${id}` , 'POST', fecha )
   
    return response
  } 
  async getExcel1(id, fecha) {
    const response = await http(`${API_URL}/excel/${id}` , 'POST', fecha )
   
    return response
  } 
  async getExcel(id, fecha1, fecha2) {

    return url(`${API_URL}/excel/${id}/${fecha1}/${fecha2}`)
 
  } 
  async getType() {
    const response = await http(`${API_URL}/type_accident/all`)
    return response
  } 
  async getAllAccidentPage(companiesID, page, search) {
    const response = await http(`${API_URL}/company/${companiesID}?page=${page}&search=${search}` , 'POST')
    return response || null
  }
 

  async getAccident(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }



  async updateAccident(id, accident) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', accident)
    return response
  }
 
  async deleteAccident(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

  async getAllAccidents(companiesID) {
    const response = await http(`${API_URL}/forcompany/${companiesID}`)
    return response || null
  }
  


  
}

export default new accidentAPI()